import React from "react"
import {useTranslation} from "next-i18next"
import Typography from "../../reusable/Typography/Typography"
import Image from "next/image"
import NavLink from "../../reusable/components/NavLink/NavLink"
import urlParams from "../../../utility/UrlParams"

const links = [
	{id: 1, label: "gearShift-link-1", params: {[urlParams.categories]: "e-urban"}},
	{id: 2, label: "gearShift-link-2", params: {[urlParams.categories]: "e-trekking"}},
	{id: 3, label: "gearShift-link-3", params: {[urlParams.categories]: "e-mountain"}}
]

const GangschaltungContent = (): React.ReactElement => {
	const {t} = useTranslation("consultationPage")
	return (
		<>
			<Typography style={{marginBottom: "32px"}}
				variant="heading28To36"
				semanticTag="h2">{t("gearShift")}</Typography>
			<Typography variant="bodyLg"
				semanticTag="p">{t("gearShift-para-1-1")}</Typography>
			<Typography className="pb-4 mb-3"
				variant="bodyLg"
				semanticTag="p">{t("gearShift-para-1-2")}</Typography>

			<Typography className="mb-4"
				variant="heading20To28"
				semanticTag="h2">{t("gearShift-heading-2")}</Typography>
			<Typography variant="bodyLg"
				semanticTag="p">{t("gearShift-para-2-1")}</Typography>
			<Typography variant="bodyLg"
				semanticTag="p">{t("gearShift-para-2-1")}</Typography>

			<div className="d-flex justify-content-center my-5">
				<Image src="/assets/images/consultation-page/gangschaltung.jpg"
					height={320}
					width={568}
					objectFit="contain"/>
			</div>

			<Typography className="mb-4"
				variant="heading20To28"
				semanticTag="h2">{t("gearShift-heading-3")}</Typography>
			<Typography className="pb-4"
				variant="bodyLg"
				semanticTag="p">{t("gearShift-para-3")}</Typography>

			<Typography className="mb-4"
				variant="heading20To28"
				semanticTag="h2">{t("gearShift-heading-4")}</Typography>
			<Typography variant="bodyLg"
				semanticTag="p">{t("gearShift-para-4-1")}</Typography>
			<Typography className="mb-4 pb-3"
				variant="bodyLg"
				semanticTag="p">{t("gearShift-para-4-2")}</Typography>

			<Typography className="mb-4"
				variant="heading20To28"
				semanticTag="h2">{t("gearShift-heading-5")}</Typography>
			<Typography variant="bodyLg"
				semanticTag="p">{t("gearShift-para-5-1")}</Typography>
			<Typography className="mb-4"
				variant="bodyLg"
				semanticTag="p">{t("gearShift-para-5-2")}</Typography>

			<ul className="list-unstyled ">
				{links.map(({id, label, params}) => <NavLink isNewLinkDesign
					translate={t}
					className="mb-4"
					key={id}
					params={params}
					label={label}/>)}
			</ul>

			<Typography className="mb-4"
				variant="heading20To28"
				semanticTag="h2">{t("gearShift-heading-6")}</Typography>
			<Typography variant="bodyLg"
				semanticTag="p">{t("gearShift-para-6")}</Typography>

		</>)
}

export default GangschaltungContent
